import { OrganizationPlan } from "@/types/api"

/** True when the org’s subscription record exists but is no longer active (cancelled). */
export function isOrganizationPlanCancelled(plan: OrganizationPlan | null | undefined): boolean {
  if (!plan?.status) return false
  const s = plan.status.toLowerCase()
  return s === "cancelled" || s === "canceled"
}
